import React from "react";
import { FiPhoneCall } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { SAURABH } from "../utils/siteData";
import { buildWhatsAppLink } from "../utils/whatsapp";

/**
 * Sticky bottom call/WhatsApp bar, visible only on small screens.
 * Provides one-tap booking on mobile where the floating button is small.
 */
export default function MobileBookBar() {
  const waLink = buildWhatsAppLink(
    SAURABH.whatsapp,
    "Namaste 🙏, I would like to book a pooja / astrology consultation."
  );

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40">
      <div className="mx-auto max-w-md grid grid-cols-2 gap-px bg-gold-300/40 shadow-premium-lg">
        <a
          href={`tel:+91${SAURABH.phone}`}
          className="flex items-center justify-center gap-2 bg-maroon-gradient text-gold-100 font-semibold py-3.5 text-sm"
        >
          <FiPhoneCall size={18} /> Call Now
        </a>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-center gap-2 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold py-3.5 text-sm"
        >
          <FaWhatsapp size={18} /> WhatsApp
        </a>
      </div>
    </div>
  );
}
